import { Error404Page } from '@components/modules/error';
import { isValidUuid } from '@shared/utils';
import { useParams } from 'react-router-dom';

/** Generic, URL-safe payment id token for canonical success URLs. */
const URL_SAFE_PAYMENT_ID = /^[a-zA-Z0-9_-]+$/;

type Props = {
  paramName?: string;
  children: React.ReactElement;
};

export const QuickPaySuccessReceiptGuard: React.FC<Props> = ({
  paramName = 'paymentId',
  children,
}) => {
  const params = useParams();
  const value = params[paramName];
  const accessKey = params.accessKey;

  if (accessKey !== undefined && !isValidUuid(accessKey)) {
    return <Error404Page source="quickpay-guard" detail="invalid access key" />;
  }

  if (value !== undefined && !URL_SAFE_PAYMENT_ID.test(value)) {
    return <Error404Page source="quickpay-guard" detail={`param "${paramName}" = "${value}"`} />;
  }

  return children;
};

QuickPaySuccessReceiptGuard.displayName = 'QuickPaySuccessReceiptGuard';
